export default "__VITE_ASSET__C0H_6hza__"